import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import EditorLayout from "../../../../components/Layouts/EditorLayout";
import SMCTextInput from "../../../../components/Simple/SMCTextInput";
import SMCField from "../../../../components/Simple/SMCField";
import { PortalSettingsGetSchema } from "../../../../api/DBSchema/PortalSettings";
import SMCButton from "../../../../components/Simple/SMCButton";
import SMCNumberInput from "../../../../components/Simple/SMCNumberInput";
import SMCLabel from "../../../../components/Simple/SMCLabel";
import {SMCToggleSwitch} from "../../../../components/Simple/SMCToggleSwitch";

const pageSchema = PortalSettingsGetSchema.pages.dns;
const pageId = pageSchema.pageId;

function PortalSettingsDns({ portalSettingsObject, setPortalSettingsData }) {
  const { t } = useTranslation();
  const pageData = portalSettingsObject[pageId];
  const setPageValue = useCallback(
    (paramName, value) => {
      setPortalSettingsData([pageId, paramName], value);
    },
    [setPortalSettingsData]
  );
  const dynamicIPTTL = pageData[pageSchema.dynamicIPTTL];
  const subDomain = pageData[pageSchema.subDomain];
  const staticIPTTL = pageData[pageSchema.staticIPTTL];
  const enabled = pageData[pageSchema.ddnsEnabled];
  const defaultDDNSDomain = pageData[pageSchema.defaultDDNSDomain];
  const smpName =
    portalSettingsObject[PortalSettingsGetSchema.pages.general.pageId].smpName;
  return (
    <EditorLayout>
      <SMCToggleSwitch
        checked={enabled}
        label={"Enable DDNS"}
        onChange={checked => {
          setPageValue(pageSchema.ddnsEnabled, checked);
        }}
      ></SMCToggleSwitch>
      {enabled && (
        <>
          <SMCField>
            <SMCTextInput
              value={subDomain}
              regexoEx={
                "^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$"
              }
              validationMsg={
                "Please enter a valid domain suffix (AlphaNumeric or '-')"
              }
              onChange={(e) =>
                setPageValue(pageSchema.subDomain, e.target.value)
              }
              label={t("SMP.SETTINGS.DNS.DOMAIN_SUFFIX")}
              tooltip={t("SMP.SETTINGS.DNS.DOMAIN_SUFFIX.TOOLTIP")}
              style={
                subDomain === smpName.replaceAll(/^a-zA-z0-9]{1,}/gm, "-")
                  ? { fontStyle: "italic", color: "gray" }
                  : {}
              }
            />
            <SMCButton
              onClick={() => {
                setPageValue(
                  pageSchema.subDomain,
                  smpName.replaceAll(/^a-zA-Z0-9]{1,}/gm, "-")
                );
              }}
            >
              {t("Reset")}
            </SMCButton>
          </SMCField>

          <div style={{ display: "block", marginLeft: "200px" }}>
            <SMCLabel
              text={`${subDomain}.${defaultDDNSDomain}`}
              style={
                subDomain === smpName.replaceAll(/^a-zA-z0-9]{1,}/gm, "-")
                  ? { fontStyle: "italic", color: "gray" }
                  : {}
              }
            />
          </div>

          <div>
            <SMCNumberInput
              disabled={!enabled}
              value={dynamicIPTTL}
              onChange={(e) =>
                setPageValue(pageSchema.dynamicIPTTL, parseInt(e.target.value))
              }
              label={t("SMP.SETTINGS.DNS.LINE1")}
              tooltip={t("SMP.SETTINGS.DNS.LINE1.TOOLTIP")}
              inline
            />
            <span>{t("SMP.SETTINGS.DNS.SECONDS")}</span>
          </div>
          <div>
            <SMCNumberInput
              disabled={!enabled}
              value={staticIPTTL}
              onChange={(e) =>
                setPageValue(pageSchema.staticIPTTL, parseInt(e.target.value))
              }
              label={t("SMP.SETTINGS.DNS.LINE2")}
              tooltip={t("SMP.SETTINGS.DNS.LINE2.TOOLTIP")}
              inline
            />
            <span>{t("SMP.SETTINGS.DNS.SECONDS")}</span>
          </div>
        </>
      )}
    </EditorLayout>
  );
}

export default PortalSettingsDns;
